import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3e881ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "invenoty-hero-module-content" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "first-line" }, "Oops", -1));
const _hoisted_3 = { class: "second-line" };
const _hoisted_4 = { class: "page-container" };
import { onBeforeMount, ref } from "vue";
import OneDeskHeroModule from "@/components/atoms/OneDeskHeroModule.vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { useRoute, useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ErrorPageView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const code = ref("");
        const goHome = () => {
            router.push({ path: "/home" });
        };
        onBeforeMount(() => {
            if (route.fullPath.length > 0) {
                switch (route.fullPath) {
                    case "/error/401":
                        code.value = "401";
                        break;
                    case "/error/403":
                        code.value = "403";
                        break;
                    case "/error/404":
                        code.value = "404";
                        break;
                    case "/error/500":
                        code.value = "500";
                        break;
                    case "/error/503":
                        code.value = "503";
                        break;
                    default:
                        code.value = "";
                        break;
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(OneDeskHeroModule, { for: "inventory" }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _hoisted_2,
                            _createElementVNode("div", _hoisted_3, " Impossible to display this page (" + _toDisplayString(code.value) + ") ", 1)
                        ])
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(OneDeskButton, {
                        class: "catalog-service-search-button",
                        "with-radius": true,
                        onClick: _cache[0] || (_cache[0] = ($event) => (goHome()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" Back to Home ")
                        ]),
                        _: 1
                    })
                ])
            ], 64));
        };
    }
});
